import React from 'react';
import { Button, ButtonProps } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';

interface AddButtonProps extends ButtonProps {
    text: string;
    onClick: () => void;
    sx?: SxProps<Theme>;
}

const AddButton: React.FC<AddButtonProps> = ({
    text,
    onClick,
    sx = {},
    ...rest
}) => (
    <Button
        type="button"
        sx={{
            color: 'white',
            background: 'linear-gradient(to bottom, #0870b4, #0870b4)', // Example colors
            px: 2,
            py: 2, // Adjust padding if needed
            height: 36,
            borderRadius: 2,
            transition: 'transform 0.3s ease-in-out',
            transform: 'scale(1)',
            '&:hover': {
                transform: 'scale(1.05)',
                background: 'linear-gradient(to bottom, #0870b4, #0870b4)', // Example reversed gradient
                color: 'white',
            },
            '&:focus': {
                outline: 'none',
            },
            display: 'flex',
            alignItems: 'center',
            fontWeight: 'bold',
            fontFamily: 'Jost, sans-serif', // Add Jost font
            letterSpacing: '0.1em', // Adjust the letter spacing as needed
            ...sx,
        }}
        onClick={onClick}
        {...rest}
    >
        {text}
    </Button>
);

export default AddButton;
